<link rel="stylesheet"
  href="https://demos.creative-tim.com/notus-js/assets/vendor/@fortawesome/fontawesome-free/css/all.min.css">
<link rel="stylesheet" type="text/css" href="https://cdn.knightlab.com/libs/timeline3/latest/css/timeline.css">
<div class="flex flex-col">
  <div class="relative flex justify-center mt-1">
    <img alt="..." src="../../../../../assets/img/{{city}}.jpg" class="w-1/5 h-1/5 rounded-full" />
    <h2 class="my-2 absolute bottom-0 font-light leading-relaxed text-2xl text-white cursor-default">{{city}}</h2>
  </div>
  <div class="my-3 bg-gray-50 text-right sm:px-6">
    <div *ngIf="allowed">
      <button
        class="inline-flex justify-center py-2 px-5 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-500 hover:bg-green-600"
        (click)="addQuestionContent()">
        Add Learning Question
      </button>
      <button
        class="inline-flex justify-center py-2 px-5 ml-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-yellow-500 hover:bg-yellow-600"
        (click)="addActionContent()">
        Add Activity
      </button>
    </div>
  </div>
  <i class="fas fa-info text-xl cursor-pointer bg-green-500 hover:bg-green-600 text-white place-self-center w-4 rounded-full shadow-sm pr-4 pl-2 py-1 my-1" (click)="openInfoDialog()">
  </i>
  <div class="timeline-container">
    <div id="timeline-embed"></div>
  </div>
  <button *ngIf="this.isLQ"
    class="place-self-center w-32 px-2 py-1 mt-1 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-500 hover:bg-green-600"
    (click)=openLQDialog()>
    Click for details
  </button>
  <button *ngIf="this.isAct"
    class="place-self-center w-32 px-2 py-1 mt-1 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-500 hover:bg-green-600"
    (click)=openActivityDialog()>
    Click for details
  </button>